var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-view"},[(_vm.label)?_c('div',{staticClass:"block-view__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"block-view__value"},[_vm._t("default",function(){return [_vm._v(_vm._s((_vm.text === null || _vm.text === undefined || _vm.text === '') ? '—' : _vm.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }